export default "__VITE_PUBLIC_ASSET__e7c2904e__"